/* src/app/views/display/components/display-section/display-menu-section/display-menu-section.component.scss */
/*# sourceMappingURL=display-menu-section.component.css.map */
